import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { Events } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';

import { MyApp } from './app.component';
import { AppData } from '../providers/app-data';
import { EsriObjectData } from '../providers/esri-object-data';
import { IdentifyData } from '../providers/identify-data';
import { LayerData } from '../providers/layer-data';
import { MapData } from '../providers/map-data';
import { SearchData } from '../providers/search-data';
import { SymbolData } from '../providers/symbol-data';
import { ToastData } from '../providers/toast-data';
import { Utilities } from '../providers/utilities';
import { DisclaimerPage } from '../pages/disclaimer/disclaimer';
import { HomePage } from '../pages/home/home';
import { OptionsPage } from '../pages/options/options';
import { IdentifyPage } from '../pages/identify/identify';
import { LocationList } from '../pages/location-list/location-list.component';

@NgModule({
  declarations: [
    MyApp,
    DisclaimerPage,
    HomePage,
    OptionsPage,
    IdentifyPage,
    LocationList
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    Ng2AutoCompleteModule,
    HttpClientModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    DisclaimerPage,
    HomePage,
    OptionsPage,
    IdentifyPage,
    LocationList
  ],
  providers: [
    StatusBar,
    SplashScreen, Events, AppData, EsriObjectData, IdentifyData, LayerData, MapData, SearchData, SymbolData, ToastData, Utilities,
    DisclaimerPage, OptionsPage, IdentifyPage, LocationList,
    { provide: ErrorHandler, useClass: IonicErrorHandler }
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts